import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';

import withdrawalPropTypes from '../../../withdrawalPropTypes.js';

const ItemApprovedSummary = ({ withdrawal }) => {
    let actionRequiredType;
    let content;

    if (withdrawal) {
        content = 'Vi har overført pengene til din bankkonto';
    } else {
        actionRequiredType = 'POSITIVE';
        content = 'Overfør pengene til din bankkonto';
    }

    return (
        <StatusSummaryButton
            actionRequiredType={actionRequiredType}
            href="/varen-er-godkjent"
            statusSummary="Handelen er ferdig."
        >
            {content}
        </StatusSummaryButton>
    );
};

ItemApprovedSummary.propTypes = {
    withdrawal: withdrawalPropTypes,
};

export default ItemApprovedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/summaries/itemApprovedSummary.jsx